(function () {
    'use strict';

    angular
        .module('app')
        .factory('SMSTemplatesService', SMSTemplatesService);

    SMSTemplatesService.$inject = ['$http', '$q', 'UrlService', 'DataService'];

    /**
     * @ngdoc service
     * @name SMSTemplatesService
     *
     * @description
     * Data service for sms templates.
     */
    function SMSTemplatesService($http, $q, UrlService, DataService) {
        var service = DataService('smstemplate');

        service.multiCopy = multiCopy;
        service.multiDelete = multiDelete;
        service.count = count;

        return service;

        /**
         * Deletes the specified sms templates
         *
         * @param {array} smsTemplateIds - An array of sms template ids for the sms templates to be deleted.
         * @return {promise} A promise resolved once the sms template deletion is complete, rejects with a http response if there was a server-side error.
         */
        function multiDelete(smsTemplateIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/smstemplatedelete', smsTemplateIds);
        }

        /**
         * Create copies of the specified sms templates.
         *
         * @param {array} smsTemplateIds - An array of sms template ids for the sms templates to be copied.
         * @return {promise} A promise resolved once the sms template copy is complete, rejects with a http response if there was a server-side error.
         */
        function multiCopy(smsTemplateIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/smstemplatecopy', smsTemplateIds);
        }

        /**
         * Gets the count of entity templates
         *
         * @param {bool} deleted
         * @returns {promise} A promise that resolves with the count
         */
        function count(deleted) {
            var url = UrlService.getWebAPIUrl() + '/smstemplate/count';

            if (!_.isNil(deleted)) {
                url += '?deleted=' + deleted;
            }

            return $http.get(url).then(
                function (response) {
                    return response.data;
                });
        }
    }
})();